import { render, staticRenderFns } from "./HeaderInfoBar.vue?vue&type=template&id=3b7d00e5&scoped=true"
import script from "./HeaderInfoBar.vue?vue&type=script&lang=js"
export * from "./HeaderInfoBar.vue?vue&type=script&lang=js"
import style0 from "./HeaderInfoBar.vue?vue&type=style&index=0&id=3b7d00e5&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b7d00e5",
  null
  
)

/* custom blocks */
import block0 from "./HeaderInfoBar.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {LoaderAnimation: require('/vercel/path0/components/ui/LoaderAnimation.vue').default,MarketStatus: require('/vercel/path0/components/MarketStatus.vue').default,CustomDropdown: require('/vercel/path0/components/ui/CustomDropdown.vue').default})
